module.exports = __webpack_public_path__ + "media/images/tutorial_body_pc1-04-12cdc7c15b649e73c9128bbc440fd631.png";